import { Controller } from "@hotwired/stimulus"

// A-15's countdown (plan 21-15, D-20). Display only: the guard ends the session server-side at the
// 30th minute, so a stopped or skewed clock here changes nothing. Without scripts the server-rendered
// "Ends at HH:MM" stays. Announces once at 5 and once at 1 minute; a threshold already passed when the
// page loads is not announced again.
export default class extends Controller {
  static targets = [ "clock", "announce" ]
  static values = { expiresAt: String, left: String, five: String, one: String }

  connect() {
    const left = this.secondsLeft()
    this.announced = { five: left <= 300, one: left <= 60 }
    this.tick()
    this.timer = setInterval(() => this.tick(), 1000)
  }

  disconnect() {
    clearInterval(this.timer)
  }

  tick() {
    const left = this.secondsLeft()
    const minutes = Math.floor(left / 60)
    const seconds = String(left % 60).padStart(2, "0")
    this.clockTarget.textContent = this.leftValue.replace("%{time}", `${minutes}:${seconds}`)

    if (left <= 300 && !this.announced.five) this.announce("five")
    if (left <= 60 && !this.announced.one) this.announce("one")
    if (left === 0) clearInterval(this.timer)
  }

  announce(threshold) {
    this.announced[threshold] = true
    this.announceTarget.textContent = threshold === "five" ? this.fiveValue : this.oneValue
  }

  secondsLeft() {
    return Math.max(0, Math.floor((Date.parse(this.expiresAtValue) - Date.now()) / 1000))
  }
}
